/** Base URL for API assets referenced directly (e.g. <img src>) and downloads. */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? ''

/** Builds an absolute-or-relative API URL for use in the browser (img/anchor). */
export function apiUrl(path: string): string {
  return `${apiBaseUrl}${path}`
}
